module.exports = __webpack_public_path__ + "static/media/x-icon.8acb4a1d.svg";